<template>
  <div id="hisPage">
    <!-- 历史委托查询 -->
    <div class="transcc_new_NewFooter_tabs_mid">
      <div class="transcc_search">
        <!-- <div class="itemSearch">
          <span class="title">商品代码</span>
          <el-select
            v-model="search.commodityCode"
            class="searchSelect"
            size="small"
            filterable
            placeholder="显示全部"
            @change="changeCode"
          >
            <el-option
              v-for="item in commodityOptions"
              :key="item.symbolCode"
              :label="item.commodityCode"
              :value="item.commodityCode"
            >
            </el-option>
          </el-select>
        </div> -->
        <div class="itemSearch">
          <span class="title">商品名称</span>
          <el-select
           :popper-append-to-body="true"
            v-model="search.symbol"
            class="searchSelect"
            popper-class="_wtCjStyle"
            size="small"
            placeholder="显示全部"
            @change="changeSymbol"
          >
            <el-option
              v-for="item in commodityOptions"
              :key="item.symbolCode"
              :label="item.symbol"
              :value="item.symbol"
            >
            </el-option>
          </el-select>
        </div>
        <div class="itemSearch">
          <span class="title decTitle">买 | 卖</span>
          <el-select
           :popper-append-to-body="true"
            v-model="search.bsFlag"
            class="searchSelect"
            popper-class="_wtCjStyle"
            size="small"
            placeholder="显示全部"
          >
            <el-option
              v-for="item in bsFlagOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="itemSearch">
          <span class="title decTitle">状态</span>
          <el-select
          :popper-append-to-body="true"
            v-model="search.status"
            class="searchSelect"
            popper-class="_wtCjStyle"
            size="small"
            placeholder="显示全部"
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="itemSearch" style="margin-left:10px">
          <el-date-picker
            popper-class="dark_date"
            v-model="search.time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyyMMdd"
            :default-time="['00:00:00', '23:59:59']"
            :clearable="false"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </div>
        <div class="itemSearch actionSearch">
          <el-button
            plain
            class="errorBtn"
            size="small"
            style="width: 74px;height: 24px;color:#0486fe;background: #D94066;font-size:14px;"
            @click="searchOrder"
          >查询</el-button>
          <el-button
            class="greenBtn"
            size="small"
            style="width: 74px;height: 24px;color:#fff;background: #41B37D;font-size:14px;"
            @click="resetOrder"
          >重置</el-button>
        </div>
        <!-- <div class="itemSearch">
          <span class="title miTitle">只显示止盈止损单</span>
          <el-switch
            v-model="value"
            class="searchSelect"
            active-color="#13ce66"
            inactive-color="#D9D9D9"
          >
          </el-switch>
        </div> -->
      </div>
    </div>
    <div class="transcc_new_NewFooter_tabs_tabBox">
      <!-- <div class="transcc_new_NewFooter_tabs_tabBox_head"> -->
      <el-table
        class="table_style"
        ref="table"
        :key="6"
        :data="tableData"
        height="256"
        row-class-name="row"
        style="width: 100%;"
        :cell-class-name="directionClass"
        show-summary
        :summary-method="getSummaries"
        @sort-change="sortChange"
      >
        <template slot="empty">
          <div v-if="isNetWrong" class="no-datas1"><div class="no-data-img" style="margin: 20px auto 0px; width: 100px; height: 100px;"><img src="../../../assets/images/no_data.png" alt="" style="width: 100%;"></div><div class="no-data" style="margin-top: -15px !important; text-align: center;" @click="showData">加载失败,点击重试</div></div>
          <div v-else class="no-datas1"><div class="no-data-img" style="margin: 20px auto 0px; width: 100px; height: 100px;"><img src="../../../assets/images/no_data.png" alt="" style="width: 100%;"></div><div class="no-data" style="margin-top: -15px !important; text-align: center;">暂无数据</div></div>
        </template>
        <el-table-column
          prop="orderId"
          label="委托单号"
          min-width="70"
          align="center"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="commodityCode"
          label="商品代码"
          width="120"
        >
        </el-table-column> -->
        <el-table-column
          prop="commodityName"
          label="商品名称"
          align="center"
          min-width="120"
        >
        </el-table-column>
        <el-table-column
          prop="bsFlag"
          label="买 | 卖"
          sortable="custom"
          align="center"
          min-width="80"
        >
          <!-- <template slot-scope="scope">
            <span :class="scope.row.bsFlag=='B'?'red-row':'green-row'"> {{ scope.row.bsFlag=='B'?'买入':'卖出' }}</span>
          </template> -->
        </el-table-column>
        <el-table-column prop="orderType" label="订立 | 转让" min-width="110" align="center">
          <template slot-scope="scope">
            {{ scope.row.orderType|tradeTypeFormat }}
          </template>
        </el-table-column>
        <el-table-column
          prop="singlePrice"
          label="委托价格"
          sortable="custom"
          min-width="110"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ Number(scope.row.singlePrice).toFixed(scope.row.priceScale) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="initQuantity"
          label="委托数量"
         align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.initQuantity }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="availableQuantity"
          label="已成交数量"
          min-width="90"
          align="center"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.availableQuantity }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="quantity"
          label="未成交数量"
          min-width="90"
          align="center"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.quantity }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="orderStatus"
          label="状态"
          min-width="120"
          align="center"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.orderStatus }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="委托时间"
          min-width="155"
          align="center"
        >

        </el-table-column>
        <!-- <el-table-column
          prop="cancledate"
          label="撤单时间"
          min-width="165"
        >
        </el-table-column> -->
      </el-table>
      <el-row v-if="pageData.total">
        <el-col :span="24">
          <el-pagination
            class="pagination_style"
            :current-page="pageData.currentPage"
            :page-size="pageData.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
/*global http protocol util*/

export default {
  data() {
    return {
      pickerOptions: {
        disabledDate: (time) => {
          // 标准化的时间对象（当前日期时间）
          const now = new Date();
          
          // 计算最小日期（7天前）
          const minDate = new Date(now);
          minDate.setDate(minDate.getDate() - 7);
          minDate.setHours(0, 0, 0, 0);
          
          // 最大日期（今天）
          const maxDate = new Date(now);
          maxDate.setHours(23, 59, 59, 999);
          
          // 创建传入时间对象的标准化副本（去掉时间部分）
          const timeDate = new Date(time.getFullYear(), time.getMonth(), time.getDate());
          
          // 最小日期和最大日期的标准化版本
          const minDateNormalized = new Date(minDate.getFullYear(), minDate.getMonth(), minDate.getDate());
          const maxDateNormalized = new Date(maxDate.getFullYear(), maxDate.getMonth(), maxDate.getDate());
          
          return timeDate < minDateNormalized || timeDate > maxDateNormalized;
        }
      },
      checked: false,
      tableData: [
        // {
        //   bsFlag: 'B',
        //   commodityCode: 'YH2210',
        //   commodityId: 243,
        //   commodityName: '红皮洋葱2210',
        //   createTime: 1639487653000,
        //   firmId: 5852,
        //   frozeFee: 12.01,
        //   frozeMargin: 800.6,
        //   holdDetailId: null,
        //   minPriceChange: 1,
        //   ocFlag: 'O',
        //   orderId: 931872,
        //   orderStatus: 1,
        //   orderType: 1,
        //   priceScale: 0,
        //   quantity: 1,
        //   singlePrice: 4003,
        //   tradeDay: 20211214,
        //   unDealQuantity: 1,
        //   unitNumeral: 1,
        //   updateTime: 1639487653000,
        //   updateTimeMs: 1639487653889
        // }
      ],
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 6,
        currentPage: 1
      },
      search: {
        commodityCode: null,
        symbol: '全部',
        bsFlag: null,
        status: null,
        floatPl: null,
        startTime: null,
        endTime: null,
        time: null,
        commodityId: null
      },
      bsFlagOptions: [{
        value: null,
        label: '全部'
      },
      {
        value: 'B',
        label: '买入'
      }, {
        value: 'S',
        label: '卖出'
      }],
      statusOptions: [
        {
          value: null,
          label: '全部'
        },
        {
          value: '1',
          label: '已委托'
        },
        {
          value: '4',
          label: '部分成交'
        },
        {
          value: '2',
          label: '已成交'
        },
        {
          value: '3',
          label: '已撤单'
        },
        {
          value: '5',
          label: '部分成交后撤单'
        }
        // {
        //   value: '6',
        //   label: '止盈'
        // },
        // {
        //   value: '7',
        //   label: '止损'
        // }
      ],
      isNetWrong: false,
      OrderFrontSum: {
        availableQuantity: null,
        bsFlag: '',
        cancelDealTime: null,
        commodityCode: '',
        commodityId: 0,
        commodityName: '',
        createTime: null,
        firmId: 0,
        frozeFee: null,
        frozeMargin: null,
        holdDetailId: 0,
        initQuantity: 0,
        minPriceChange: 0,
        ocFlag: '',
        orderId: 0,
        orderStatus: 0,
        orderType: 0,
        priceScale: 0,
        quantity: null,
        singlePrice: 0,
        tradeDay: 0,
        unDealQuantity: null,
        unitNumeral: 0,
        updateTime: null
      },
      selectData: [util.formatnewDay(Number(new Date()) - 24 * 7 * 60 * 60 * 1000), util.formatnewDay(Number(new Date()) - 24 * 60 * 60 * 1000)]
    }
  },
  updated() {
      this.$nextTick(() => {
          this.$refs.table.doLayout()
      })
  },
  computed: {
    commodityOptions() {
      const commodityList = structuredClone(this.$store.state.hqData.marketDetails)
      commodityList.unshift({commodityId: null,symbol: '全部'})
      return commodityList
    }
  },
  mounted() {
    this.search.time = this.selectData
    this.showData()
  },
  methods: {
    searchOrder() {
      this.pageData.currentPage = 1
      this.showData()
    },
    resetOrder() {
      this.pageData.currentPage = 1
      this.search = {
        commodityCode: null,
        symbol: '全部',
        bsFlag: null,
        status: null,
        floatPl: null,
        startTime: null,
        endTime: null,
        time: this.selectData,
        selectWay: null,
        commodityId: null
      }
      this.showData()
    },
    changeCode(code) {
      const codeOption = JSON.parse(JSON.stringify(this.commodityOptions))
      codeOption.forEach(element => {
        if (element.commodityCode === code) {
          this.search.commodityCode = element.commodityCode
          this.search.symbol = element.symbol
          this.search.commodityId = element.symbolId
          return
        }
      })
    },
    changeSymbol(symbol) {
      const codeOption = JSON.parse(JSON.stringify(this.commodityOptions))
      codeOption.forEach(element => {
         if(element.symbol == '全部'){
           this.search.commodityId = null
           this.search.symbol = element.symbol
           this.search.commodityCode = null
           return
        }else if (element.symbol === symbol) {
          this.search.symbol = element.symbol
          this.search.commodityCode = element.commodityCode
          this.search.commodityId = element.symbolId
          return
        }
      })
    },

    // 合计
    getSummaries(param) {
      const { columns } = param
      const sums = []
      const that = this
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index === 2) {
          sums[index] = '共' + this.pageData.total + '条'
          return
        }
        if (index === 5) { // 委托数量
          sums[index] = that.OrderFrontSum.initQuantity
          return
        }
        if (index === 6) { // 已成交数量
          sums[index] = that.OrderFrontSum.availableQuantity
          return
        }
        if (index === 7) { // 未成交数量
          sums[index] = that.OrderFrontSum.unDealQuantity
          return
        }
        sums[index] = ''
      })
      return sums
    },
    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.showData()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.showData()
    },
    // 查询合计
    querySum() {
      if (this.search.time) {
        // 历史
        protocol.queryOrderFrontHSum.data.startTradeDay = this.search.time[0]
        protocol.queryOrderFrontHSum.data.endTradeDay = this.search.time[1]
      } else {
        protocol.queryOrderFrontHSum.data.startTradeDay = null
        protocol.queryOrderFrontHSum.data.endTradeDay = null
      }
      protocol.queryOrderFrontHSum.data.orderType = [1, 2, 4, 15]
      protocol.queryOrderFrontHSum.data.bsFlag = this.search.bsFlag == 'A' ? null : this.search.bsFlag
      protocol.queryOrderFrontHSum.data.commodityId = this.search.commodityId
      protocol.queryOrderFrontHSum.data.orderStatus = this.search.status != null ? [this.search.status] : null
      // protocol.queryOrderFrontHSum.data.orderStatus = this.search.status != null ? [this.search.status] : null
      http.gPostHs(protocol.queryOrderFrontHSum).then(response => {
        if (response.data) {
          if (response.data && response.data.code == '0') {
            // const arr = response.data.value.content
            this.OrderFrontSum = response.data.value
          } else {
            this.$message(response.data.message)
          }
        }
      })
    },
    // 订单展示
    showData() {
      const that = this
      if (this.search.time) {
        // 历史
        protocol.queryUserEntrustHS.data.startTradeDay = this.search.time[0]
        protocol.queryUserEntrustHS.data.endTradeDay = this.search.time[1]
      } else {
        protocol.queryUserEntrustHS.data.startTradeDay = null
        protocol.queryUserEntrustHS.data.endTradeDay = null
      }
      protocol.queryUserEntrustHS.data.orderType = [1, 2, 4, 15]
      protocol.queryUserEntrustHS.data.page = this.pageData.currentPage - 1
      protocol.queryUserEntrustHS.data.size = '' + this.pageData.pageSize
      protocol.queryUserEntrustHS.data.bsFlag = this.search.bsFlag == 'A' ? null : this.search.bsFlag
      protocol.queryUserEntrustHS.data.commodityId = this.search.commodityId
      protocol.queryUserEntrustHS.data.orderStatus = this.search.status != null ? [this.search.status] : null
      http.gPostHs(protocol.queryUserEntrustHS).then(response => {
        if (response.data.code != 0) {
          this.$message({ message: response.data.message })
          this.isNetWrong = true
        } else {
          this.isNetWrong = false
        }
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.pageData.total = response.data.value.totalElements
            const arr = response.data.value.content
            this.judgeDataType(arr)
            // this.OrderFrontSum = response.data.value.sumData
          }
        }
        this.querySum()
      }).catch((e) => {
        console.log(e)
        setTimeout(() => {
          that.showData()
        }, 1000)
      })
    },
    // 判断数据类型
    judgeDataType(arr) {
      const that = this
      this.each(arr, function(arrIndex) {
        // 判断时间
        that.modifyTime(arrIndex, 'createTime')
        if (arrIndex.cancelDealTime) {
          that.modifyTime(arrIndex, 'cancelDealTime')
        }
        // 判断方向
        that.modifyData(arrIndex, 'bsFlag', 'B', '买入', '卖出')
        that.modifyData(arrIndex, 'ocFlag', 'O', '订立', '转让')
        // 判断委托状态 1-已委托，2-已成交，3-已撤单，4-部分成交，5-部分成交后撤单
        const stateList = ['已委托', '已成交', '已撤单', '部分成交', '部分成交后撤单']
        stateList.forEach((item, index) => {
          that.modifyData(arrIndex, 'orderStatus', index + 1, item)
        })
      })
      this.tableData = arr
    },
    // 排序
    sortChange(column, prop, order) {
      if (column.order == 'ascending') {
        protocol.queryUserEntrustHS.data.sort[0].direction = 'ASC'
        this.eachSortChange(column.column.property)
      } else if (column.order == 'descending') {
        protocol.queryUserEntrustHS.data.sort[0].direction = 'DESC'
        this.eachSortChange(column.column.property)
      } else {
        // 取消排序,回到默认状态
        protocol.queryUserEntrustHS.data.sort = [{
          property: 'orderId',
          direction: 'DESC'
        }]
      }
      if (column.column) {
        http.gPostHs(protocol.queryUserEntrustHS).then(response => {
          if (response.data.code != 0) {
            this.$message({ message: response.data.message })
            this.isNetWrong = true
          } else {
            this.isNetWrong = false
          }
          if (response.data) {
            if (response.data && response.data.code == '0') {
              this.pageData.total = response.data.value.totalElements
              const arr = response.data.value.content
              // this.OrderFrontSum = response.data.value.sumData
              this.judgeDataType(arr)
            }
          }
        })
      }
    },
    // 分项排序
    eachSortChange(str) {
      return (protocol.queryUserEntrustHS.data.sort[0].property = str)
    },
    // 单元格颜色
    directionClass(row, column, rowIndex, columnIndex) {
      // 根据字段改变样式
      switch (row.columnIndex) {
        // eslint-disable-next-line no-lone-blocks
        case 2: {
          return this.setStrClass(row.row.bsFlag, '卖出', 'dropColor', 'increaseColor')
        }
        case 3: {
          return this.setStrClass(row.row.ocFlag, '转让', 'dropColor', 'increaseColor')
        }
        default:
          break
      }
    }
  }

}
</script>
<style lang="scss" scoped>
/deep/ .dropColor > *{
  color: #41B37D !important;
}
/deep/ .el-table__footer-wrapper .el-table__footer{
    height: 36px !important;
}
/deep/ .el-table__row{
  height: 32px;
}
/deep/ .el-table td div{
  text-align: center;
  color: #dfdfdf;
}
/deep/ .el-table--enable-row-hover .el-table__body tr:hover>td{
  background-color: #222324 !important;
}
/deep/ .el-table table tr{
   background-color: #161719;
}
</style>
<style lang="scss" scoped>
//el-selecl Style
::v-deep .el-input--small .el-input__icon{
  line-height: 26px;
}
.el-select-dropdown__item.selected{
  color: #989898
}
</style>
<style lang="scss" scoped>
/deep/ .el-date-editor .el-range-separator{
  line-height: 18px !important;
}
/deep/ .el-table table tr{
   background-color: #161719;
}
// #threePage{
//  width:calc(100% - 181px);
// }
.transcc_search{
  display:flex;
  justify-content: flex-start;
  align-items: center;
  margin: 3px 0;
  .itemSearch{
    display:flex;
    justify-content: flex-start;
    align-items: center;
    .title{
      width:60px;
      font-size:14px;
      // margin:0 10px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.6);
    }
    .searchSelect{
      width:158px!important;
    }
    .decTitle{
      width:44px;
    }
    .miTitle{
      width:120px;
    }
  }
   /deep/ .el-input.is-focus .el-input__inner{
        border-color: #fff !important;
  }
  /deep/  .el-input__inner{
    height: 26px !important;
        background-color: transparent;
        border-color: rgba($color: #fff, $alpha: 0.3);
      }
   /deep/.el-button{
     border:none;
     border-radius: 15px;
    padding: 5px 15px !important;
   }
  /deep/.el-button span {
    color: #fff;
  }
  .actionSearch{
    margin-left:10px;
  }

}
/deep/.el-range-editor .el-range-input{
  background-color:transparent;
  color: #979797;
}
/deep/.el-date-editor .el-range-separator{
  color: #979797;
  line-height: 27px;
}
/deep/.el-date-editor .el-range__icon{
  line-height:19px;
}
.el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner{
  width:240px;
}
// .transcc_new_NewFooter_tabs_mid{
//   min-width:1200px;
// }
 .transcc_query_search {
        margin-top: 16px;
        .el-button{
          width:52px;
          height: 32px;
          background-color:transparent;
          border: 1px solid #363F66;
        }
      }
      .transcc_new_NewFooter_tabs_tabBox {
        height: 255px;
        width: 100%;
        min-width: 1200px;
        .row{
          background-color: #010101 !important;
        }
        .transcc_new_NewFooter_tabs_tabBox_head {
          width: 100%;
          display: flex;
          // justify-content: space-around;
          align-items: center;
          height: 60px;
          .tab_head_item {
            width: 130px;
            margin-left: 10px;
            display: flex;
            align-items: center;
            height: 14px;
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(255, 255, 255, 0.6);
            line-height: 14px;
          }
        }
        .borderline {
          width: 100%;
          height: 1px;
          background: linear-gradient(
            45deg,
            rgba(94, 101, 146, 0.4) 0%,
            #464c74 53%,
            rgba(48, 53, 89, 0.4) 100%
          );
        }
      }
</style>
<style lang="scss">
.dark_date{
  background: #010101 !important;
  /* 添加禁用日期的样式 */
  /* 添加禁用日期的样式 */
  .el-date-table {
    td.disabled div {
      background-color: #010101 !important; /* 纯黑色背景 */
    }
    
    td.disabled .el-date-table-cell__text {
      color: #333 !important; /* 深灰色文字 */
      background-color: transparent !important;
    }
    
    td.disabled .el-date-table-cell::before {
      background-color: #333 !important; /* 深灰色圆点 */
    }
    
    td.disabled.today .el-date-table-cell__text {
      color: #555 !important; /* 稍亮的灰色 */
    }
    
    td.disabled:hover .el-date-table-cell__text {
      color: #444 !important; /* 悬停状态微亮 */
    }
  }
  &.el-date-range-picker{
    background-color: #010101 !important;
    .el-date-range-picker__header{
      color: #fff;
      .el-picker-panel__icon-btn{
        color: #fff;
      }
    }
    .el-date-table td.in-range div{
      background: #ffffff;
    }
    .el-date-table td.end-date span,.el-date-table td.start-date span{
      background: #010101;
      color:#e7e7e7 !important;
    }
    .el-date-table td.in-range span{
      color: #010101;
    }
    .el-date-table td.in-range.today span{
      font-weight: 600;
      color: #010101;
    }
    .el-date-table td.today{
      float: none;
      span{
        font-weight: 600;
        color:#ffffff;
      }
    } 
  }
}
</style>